import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Sesion } from '../models/sesion';

@Injectable()
export class SesionService {

  private urlEndPointSesion: string = environment.sesionEndPoint;

  constructor(private http: HttpClient) { }

  consultarDatosSesion(): Observable<Sesion> {
    return this.http.get(this.urlEndPointSesion + '/datos').pipe(
      map((respuesta) => respuesta as Sesion)
    );
  }

  permisoCrearVlan(): Observable<boolean> {
    return this.http.get<boolean>(this.urlEndPointSesion + '/permiso/crear-vlan');
  }

  permisoAsignacionManual(): Observable<boolean> {
    return this.http.get<boolean>(this.urlEndPointSesion + '/permiso/asignacion-manual');
  }

  permisoInactivarVLAN(): Observable<boolean> {
    return this.http.get<boolean>(this.urlEndPointSesion + '/permiso/inactivar-vlan');
  }

  permisoCrearVlanSede(): Observable<boolean> {
    return this.http.get<boolean>(this.urlEndPointSesion + '/permiso/inactivar-vlan');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/sesion.service.ts